import { __assign, __makeTemplateObject } from "tslib";
/** @jsx jsx */
import { createElement, forwardRef, Fragment, } from 'react';
import { ClassNames, jsx } from '@emotion/core';
import { B200, backgroundActive, backgroundHover, } from '@atlaskit/theme/colors';
import { borderRadius, gridSize } from '@atlaskit/theme/constants';
import { BORDER_WIDTH } from './constants';
import Text from './Text';
import { getButtonProps, getCustomElement, getLinkProps } from './utilities';
var getStyles = function (css, _a) {
    var backgroundColor = _a.backgroundColor, isInteractive = _a.isInteractive, isDisabled = _a.isDisabled;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: ", "px solid transparent;\n  box-sizing: border-box;\n  color: inherit;\n  display: flex;\n  font-size: inherit;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  outline: none;\n  margin: 0;\n  padding: ", "px;\n  text-align: left;\n  text-decoration: none;\n  width: 100%;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: ", "px solid transparent;\n  box-sizing: border-box;\n  color: inherit;\n  display: flex;\n  font-size: inherit;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  outline: none;\n  margin: 0;\n  padding: ", "px;\n  text-align: left;\n  text-decoration: none;\n  width: 100%;\n  cursor: pointer;\n\n  ",
        "\n\n  ",
        "\n"])), backgroundColor, borderRadius(), BORDER_WIDTH, gridSize() / 2, isInteractive &&
        "\n        :hover {\n          background-color: " + backgroundHover() + ";\n          text-decoration: none;\n        }\n\n        :focus {\n          outline: none;\n          border-color: " + B200 + ";\n        }\n\n        :active {\n          background-color: " + backgroundActive() + ";\n        }\n      ", isDisabled &&
        "\n        cursor: not-allowed;\n        opacity: 0.75;\n        pointer-events: none;\n      ");
};
var AvatarItem = forwardRef(function (_a, ref) {
    var avatar = _a.avatar, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'transparent' : _b, children = _a.children, isTruncationDisabled = _a.isTruncationDisabled, href = _a.href, isDisabled = _a.isDisabled, onClick = _a.onClick, primaryText = _a.primaryText, secondaryText = _a.secondaryText, target = _a.target, testId = _a.testId;
    var onClickHandler = function (event) {
        if (isDisabled || typeof onClick !== 'function') {
            return;
        }
        onClick(event);
    };
    var getTestId = function (testId, children) {
        return !children
            ? { 'data-testid': testId + "--itemInner" }
            : { testId: testId + "--itemInner" };
    };
    return (jsx(ClassNames, null, function (_a) {
        var css = _a.css;
        var props = __assign(__assign(__assign(__assign({ ref: ref, className: getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
            }) }, (href && getLinkProps(href, target))), (onClick && getButtonProps(onClickHandler, isDisabled))), (testId && getTestId(testId, children))), { children: (jsx(Fragment, null,
                avatar,
                jsx("div", { css: {
                        maxWidth: '100%',
                        minWidth: 0,
                        flex: '1 1 100%',
                        lineHeight: '1.4',
                        paddingLeft: gridSize() + "px",
                    } },
                    jsx(Text, { truncate: !isTruncationDisabled }, primaryText),
                    jsx(Text, { secondary: true, truncate: !isTruncationDisabled }, secondaryText)))) });
        return children
            ? children(props)
            : createElement(getCustomElement(href, onClick), props);
    }));
});
AvatarItem.displayName = 'AvatarItem';
export default AvatarItem;
var templateObject_1;
//# sourceMappingURL=AvatarItem.js.map